
import React, { useState } from 'react';
import { Button } from '../ui/button';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

const ClassStatusForm = ({ currentStatus, onSubmit, onCancel }) => {
  const [status, setStatus] = useState(currentStatus);
  const [reason, setReason] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Send status and reason as an object to parent component
    onSubmit({ 
      status,
      reason: reason.trim() !== '' ? reason : undefined
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <h3 className="text-sm font-medium mb-3">Update Teacher Status</h3>
        <RadioGroup value={status} onValueChange={setStatus} className="space-y-3">
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="present" id="present" />
            <Label htmlFor="present" className="text-green-700">Present (Active/On Time)</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="late" id="late" />
            <Label htmlFor="late" className="text-yellow-700">Late</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="absent" id="absent" />
            <Label htmlFor="absent" className="text-red-700">Absent (Needs Substitute)</Label>
          </div>
        </RadioGroup>
      </div>

      {status !== 'present' && (
        <div>
          <Label htmlFor="reason">Reason (optional)</Label>
          <Textarea
            id="reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason for absence or lateness"
            className="mt-1"
          />
        </div>
      )}

      <div className="flex space-x-2 justify-end">
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">
          Update Status
        </Button>
      </div>
    </form>
  );
};

export default ClassStatusForm;
